import styled from 'styled-components'
import { colors } from '@chegg-ui/theme'

export const MoveCitationsCopyContainer = styled.div``
export const MoveCitationsCopyText = styled.span``
export const MoveCitationsCopyLink = styled.a`
  text-decoration: none;
  font-weight: bold;
  color: ${colors.link};
  &:hover {
    text-decoration: underline;
  }
`
